import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Marketplaces } from "./components/Marketplaces";
import { Inventory } from "./components/Inventory";
import { About } from "./components/About";
import { Social } from "./components/Social";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";

export default function App() {
  return (
    <div className="min-h-screen overflow-x-clip bg-[#0B0C10] font-body text-zinc-100 antialiased">
      <Header />
      <main>
        <Hero />
        <Marketplaces />
        <Inventory />
        <About />
        <Social />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
